export default "__VITE_ASSET__7a248915__"